package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_05_17_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-05-17")
@Composable
public fun Log_2024_05_17(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Goristro Jarb",
        ogTitle = "The Goristro Jarb",
        date = LocalDate(2_024, 5, 17),
        ogDescription = "The heroes encounter Jarb the Ascended and the Chasme Sklyx in a lava-filled chamber, starting a brutal battle.",
        ogImage = "ai/2024-05-17.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-52", dateString = "Newgrowth 52")
        Log_2024_05_17_Day_1()
    }
}
